import {ReactNode} from 'react'

interface ListingGridProps {
  children: ReactNode
  loading?: boolean
}

export function ListingGrid({ children, loading }: ListingGridProps) {
  if (loading) {
    return (
      <div className="mp-grid">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="mp-card mp-card--skeleton">
            <div className="mp-card__image mp-card__image--skeleton"></div>
            <div className="mp-card__content">
              <div className="mp-card__skeleton-line mp-card__skeleton-line--short"></div>
              <div className="mp-card__skeleton-line mp-card__skeleton-line--long"></div>
              <div className="mp-card__skeleton-line mp-card__skeleton-line--medium"></div>
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="mp-grid">
      {children}
    </div>
  )
}

// Empty State Component
export function EmptyState({
  icon = 'box-seam',
  title = 'אין מודעות',
  description = 'אין מודעות להצגה כרגע',
  actionLabel,
  onAction
}: {
  icon?: string
  title?: string
  description?: string
  actionLabel?: string
  onAction?: () => void
}) {
  return (
    <div className="mp-empty">
      <div className="mp-empty__icon">
        <i className={`bi bi-${icon}`}></i>
      </div>
      <h3 className="mp-empty__title">{title}</h3>
      <p className="mp-empty__description">{description}</p>
      {actionLabel && onAction && (
        <button className="mp-empty__action" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  )
}
